import { render } from "./AggregateInfoMngMenu.vue?vue&type=template&id=a5200bca&scoped=true"
import script from "./AggregateInfoMngMenu.vue?vue&type=script&lang=js"
export * from "./AggregateInfoMngMenu.vue?vue&type=script&lang=js"

import "./AggregateInfoMngMenu.vue?vue&type=style&index=0&id=a5200bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5200bca"]])

export default __exports__